
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: {
    IconButton
  }
})
export default class IconButtonShuffle extends Vue {
  isRotating = false;

  @Prop()
  size!: "small" | "default";

  handleClick(event: MouseEvent) {
    this.isRotating = true;
    this.$emit("update", event);
    setTimeout(() => {
      this.isRotating = false;
    }, 600);
  }
}
